import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getElementControls } from "core-integration/src/store/elements/reducers";
import { IElement } from "core-integration/src/store/elements/types";
import { getStatDetails, getStatNames } from "../../utils/stats";
import { FieldWrap, SelectField } from "../FieldRenderers";

interface ISortOption {
  label: string;
  value: keyof IElement;
}

type Props = WithTranslation & {
  handleSortChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  sortOptions?: ISortOption[];
};

const ElementSort = ({ handleSortChange, t }: Props) => {
  const controls = useSelector(getElementControls);

  const sortOptions: ISortOption[] = getStatNames(t).map((s) => ({
    label: getStatDetails(s, t)!.label,
    value: s,
  }));

  return (
    <FieldWrap>
      <SelectField
        id="sort"
        name="sort"
        label={t("sortedBy", "Sorted by")}
        value={controls.sort}
        onChange={handleSortChange}
        required={false}
      >
        {sortOptions.map((o) => (
          <option
            key={o.value}
            value={o.value}
            aria-selected={controls.filter === o.value}
          >
            {o.label}
          </option>
        ))}
      </SelectField>
    </FieldWrap>
  );
};

export default withTranslation()(ElementSort);
